import React from "react";
import classnames from "classnames";
import find from "lodash/find";
import { connect } from "react-redux";

import ProDownloadDescription from "./pro-download-description";
import ToolTip from "../tool-tip";
import * as actions from "../../actions/actions";

import "intl";
import "intl/locale-data/jsonp/en.js";

let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});

const canUseCredit = props => !props.download.processing;

const PhaseUseIconCredit = props => {
    let {
        pendingDownload,
        processing,
        prepaidBalance,
        justPurchased
    } = props.download;

    let { currentPurchase } = props;

    let classes = classnames("download-use-prepaid-container", {
        processing
    });

    let buttonClass = classnames("button", {
        lightgray: !canUseCredit(props),
        blue: canUseCredit(props),
        processing
    });

    let currentBalance = formatter.format(prepaidBalance / 100);
    let newBalance = formatter.format(
        (prepaidBalance - currentPurchase.price) / 100
    );

    let { name, term } = pendingDownload;

    let iconInfo = `${name || term} #${pendingDownload.id}`;
    let iconPrice = formatter.format(currentPurchase.price / 100);

    const numberOfIcons = Math.floor(prepaidBalance / currentPurchase.price);

    const nextNumberOfIcons = numberOfIcons - 1;

    let thankYou;
    if (justPurchased) {
        thankYou = (
            <div className="current-plan basic license-thank-you license-specific-content">
                <h1>Thanks for your purchase!</h1>
                <p>You may use your credit now or later. It never expires.</p>
            </div>
        );
    }
    return (
        <React.Fragment>
            {thankYou || <ProDownloadDescription />}
            <div className={classes}>
                <div className="balance-calculation">
                    <h4 className="price-row">
                        Prepaid balance{" "}
                        <ToolTip
                            placement="right"
                            target={<span>{currentBalance}</span>}
                        >
                            {numberOfIcons} icon
                            {numberOfIcons == 1 ? "" : "s"}
                        </ToolTip>
                    </h4>
                    <h4 className="price-row">
                        {iconInfo}
                        <span className="price-display">- {iconPrice}</span>
                    </h4>
                </div>
                <h4 className="price-row">
                    New prepaid balance{" "}
                    <ToolTip
                        placement="right"
                        target={
                            <span className="price-display">{newBalance}</span>
                        }
                    >
                        {nextNumberOfIcons} icon
                        {nextNumberOfIcons == 1 ? "" : "s"}
                    </ToolTip>
                </h4>
                <div
                    className={buttonClass}
                    onClick={props.downloadPurchase.bind(null, null)}
                >
                    Use Pre–Paid Credit
                </div>
            </div>
        </React.Fragment>
    );
};

export default connect(
    state => {
        let { stripe } = state;
        let { currentPurchaseKey } = stripe;

        let currentPurchase = find(stripe.purchaseTypes, {
            key: currentPurchaseKey
        });
        return {
            currentPurchase
        };
    },
    {
        downloadPurchase: actions.downloadPurchase
    }
)(PhaseUseIconCredit);
